import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// px自动转rem
import './assets/utils/rem'

// 引入element UI
import "element-ui/lib/theme-chalk/index.css";
import ElementUI from 'element-ui';
Vue.use(ElementUI)

// 引入echarts
import * as echarts from 'echarts';
// eventBus
import Bus from "@/assets/utils/eventBus";
Vue.use(Bus)

// 引入axios
import axios from './axios'
Vue.prototype.$axios = axios

// 清除默认样式表
import './assets/css/reset.less'

Vue.config.productionTip = false
// 挂载echarts
Vue.prototype.$echarts = echarts

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
